import type { LocaleCopy } from '../types';
import { homeFr } from './home';
import { chromeFr } from './chrome';
import { aboutFr } from './about';
import { allergensFr } from './allergens';

export const fr: LocaleCopy = {
  home: homeFr,
  chrome: chromeFr,
  about: aboutFr,
  allergens: allergensFr,
};
